import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona si ya estoy en menopausia o post-menopausia?',
    a: 'Sí. Aunque el protocolo está diseñado con los cambios de la peri-menopausia en mente, los 4 pilares (estabilidad de glucosa, reducción de estrés, sueño y movimiento inteligente) son fundamentales para equilibrar las hormonas en cualquier etapa posterior a los 35 años.'
  }, {
    q: '¿Necesito comprar suplementos caros?',
    a: 'No. El enfoque principal está en la alimentación, el estilo de vida y el movimiento. Mencionamos algunos suplementos opcionales que pueden ayudar, pero no son obligatorios para ver resultados.'
  }, {
    q: '¿Es un tratamiento médico?',
    a: 'No. Es una guía educativa basada en estilo de vida y nutrición. No reemplaza el consejo de tu médico, especialmente si estás bajo Terapia de Reemplazo Hormonal u otro tratamiento.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con los enlaces para descargar el Ebook principal y todos los bonos en formato PDF. Puedes leerlos en tu celular, tablet o computadora.'
  }, {
    q: '¿Cuánto tiempo al día necesito para aplicar esto?',
    a: 'El protocolo está diseñado para mujeres ocupadas. Los cambios se integran en tu rutina diaria (como el orden en que comes tus alimentos o tu rutina antes de dormir). No necesitas horas extra en tu día.'
  }, {
    q: '¿Tengo que hacer ejercicio intenso?',
    a: 'Todo lo contrario. Explicamos por qué el ejercicio demasiado intenso (como horas de cardio) puede estar empeorando tus síntomas al elevar el cortisol. Te enseñamos a moverte de forma más inteligente, no más dura.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-primary-bg" data-id="element-32">
      <div className="max-w-3xl mx-auto" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-text-primary mb-4" data-id="element-35">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <div key={index} className="border border-text-primary/10 rounded-2xl bg-white overflow-hidden transition-all hover:border-accent/30" data-id="element-37">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-38">
                <span className="font-bold text-text-primary pr-4" data-id="element-39">
                  {faq.q}
                </span>
                <ChevronDown className={`shrink-0 text-accent transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>
              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-text-primary/70 leading-relaxed border-t border-text-primary/5 pt-4" data-id="element-43">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}